import React, {useEffect, useState} from "react";
import {API} from "../../../config/Config";
import Forms from '../../../bricks/form/Forms';
import Loading from "../../../bricks/Loading";
import {axiosInstance} from "../../../bricks/axios";
import {useAppData} from "../../../context/AppDataContext";
import FileSaver from "file-saver";

import "./BulkAboExportModalContent.scss";

const BulkAboExportModalContent = ({onHide}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [courseList, setCourseList] = useState([]);
    const {setError, selectedPeriod} = useAppData();
    const [selectedCourseList, setSelectedCourseList] = useState([]);
    const [failedGetCounterAccountUserList, setFailedGetCounterAccountUserList] = useState([]);

    useEffect(() => {
        const load = async () => {
            try {
                setIsLoading(true);
                const {method, url} = API.loadDrawnCourses(selectedPeriod);
                const {data} = await axiosInstance[method](url);
                setCourseList(data);
            } catch (e) {
                setError(e);
            } finally {
                setIsLoading(false);
            }
        }
        load();
    }, [selectedPeriod]);

    const onSubmit = async (event) => {
        event.preventDefault();
        try {
            const {method, url} = API.generateBulkAboPayment;
            const {data} = await axiosInstance[method](url, {selectedCourseList});

            // download the blob file
            const {method: method2, url: url2} = API.downloadAboExport;
            const res = await axiosInstance[method2](url2, {aboFilePath: data.aboFilePath});
            const blob = new Blob([res.data], {type: 'text/plain'}); // Konverze řetězce na blob

            FileSaver.saveAs(blob, `platebni-prikaz_${selectedPeriod}.abo`);

            if (data.failedGetCounterAccountUserList.length) {
                setFailedGetCounterAccountUserList(data.failedGetCounterAccountUserList);
            } else {
                onHide();
            }
        } catch (e) {
            setError(e);
        }
    }

    const _renderContent = () => {
        if (isLoading) {
            return <Loading/>;
        } else {
            return (
                <>
                    <Forms.Button onClick={() => setSelectedCourseList(courseList.map(({_id}) => _id))}
                                  label={"Vybrat vše"}/>
                    <Forms.Button onClick={() => setSelectedCourseList([])}
                                  label={"Zrušit vše"}/>
                    <div className="container">
                        <Forms.Checkboxes value={selectedCourseList} onChange={(_, val) => setSelectedCourseList(val)}
                                          options={courseList.map(course => ({
                                              label: course.code,
                                              value: course._id
                                          }))}/>
                    </div>
                </>
            )
        }
    }

    return (
        <>
            <form className="BulkAboExportModalContent" onSubmit={onSubmit}>
                <label>Platební příkaz lze generovat pouze pro kuryz, které jsou slosované</label>
                <div>
                    {_renderContent()}
                </div>
                {
                    failedGetCounterAccountUserList.length > 0 && (
                        <div className="failedGetCounterAccountUserList">
                            <label>Seznam uživatelů, které nebylo možné zahrnout do ABO platebního příkazu!</label>
                            <table>
                                <thead>
                                <tr>
                                    <th>Uživatel</th>
                                    <th>Kurz</th>
                                    <th>Protiúčet, ze kterého přišla platba</th>
                                </tr>
                                </thead>
                                <tbody>
                                {failedGetCounterAccountUserList?.map(courseReg => (
                                    <tr>
                                        <td>{courseReg.user.name} {courseReg.user.surname}</td>
                                        <td>{courseReg.courseCode}</td>
                                        <td>{courseReg.paymentCreditedId.paymentData.counterAccount}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    )
                }
                <div className="modal-footer">
                    <div>
                        <Forms.Button type="submit" label="Stáhnout" disabled={isLoading}/>
                        <Forms.Button onClick={onHide} dark label="Zavřít" disabled={isLoading}/>
                    </div>
                </div>
            </form>
        </>
    );
}

export default BulkAboExportModalContent;
